import React, { useState } from 'react'

function IndSectionTabs({ tabData }) {
   const [activeTab, setActiveTab] = useState('01ete')
   return (
      <>
         <div className="ete-div d-xl-flex d-none">
            <div className="ete-left">
               <ul className="nav flex-column">
                  {tabData.map((tab, index) => (
                     <li
                        key={tab.id}
                        className={`nav-items ${
                           index === tabData.length - 1 ? 'remov-border' : ''
                        }`}
                     >
                        <button
                           className={`nav-links ete-tags d-flex align-items-center justify-content-between ${
                              activeTab === tab.id ? 'active' : ''
                           }`}
                           onClick={() => setActiveTab(tab.id)}
                           type="button"
                        >
                           {tab.title}
                        </button>
                     </li>
                  ))}
               </ul>
            </div>
            <div className="ete-right">
               <div className="tab-content">
                  {tabData.map((tab) => (
                     <div
                        key={tab.id}
                        className={`ete-tab-pane ${
                           activeTab === tab.id ? 'active' : ''
                        }`}
                        id={tab.id}
                     >
                        <div className="ete-tab-contant">
                           <div className="ete-tab-icon">
                              <img src={tab.icon} alt={tab.intitle} />
                           </div>
                           <h3>{tab.intitle}</h3>
                           <p>{tab.content}</p>
                        </div>
                     </div>
                  ))}
               </div>
            </div>
         </div>

         {/* Mobile devices */}
         <div
            className="accordion d-xl-none flex-column d-flex gap-2"
            id="eteAccordion"
         >
            {tabData.map((tab, index) => (
               <div key={tab.id} className="accordion-item">
                  <h2 className="accordion-header" id={`heading${tab.id}`}>
                     <button
                        className={`accordion-button ${
                           index === 0 ? '' : 'collapsed'
                        } ete-left`}
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse${tab.id}`}
                        aria-expanded={index === 0 ? 'true' : 'false'}
                        aria-controls={`collapse${tab.id}`}
                     >
                        {tab.title}
                     </button>
                  </h2>
                  <div
                     id={`collapse${tab.id}`}
                     className={`accordion-collapse collapse ${
                        index === 0 ? 'show' : ''
                     }`}
                     aria-labelledby={`heading${tab.id}`}
                     data-bs-parent="#eteAccordion"
                  >
                     <div className="accordion-body ete-right">
                        <div className="ete-tab-pane active">
                           <div className="ete-tab-contant">
                              <div className="ete-tab-icon">
                                 <img src={tab.icon} alt={tab.intitle} />
                              </div>
                              <h3>{tab.intitle}</h3>
                              <p>{tab.content}</p>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            ))}
         </div>
      </>
   )
}

export default IndSectionTabs
